// AUTO-GENERATED (gen_directory_i18n.py). 20 languages translated from FR via LLM.
// Placeholders {v}/{n} preserved; interpolated by dl()/cl() in directory.js.
export const DIR_GEN = {
 "nl": {
  "sale": {
   "direct": "Directe verkoop",
   "market": "Markt",
   "delivery": "Levering",
   "pickup": "Afhalen ter plaatse",
   "online": "Webwinkel",
   "phone": "Bestellen per telefoon",
   "email": "Bestellen per e-mail"
  },
  "precision": {
   "exact": "Exact adres",
   "approx": "Approximate adres",
   "city": "Alleen stad",
   "region": "Alleen regio",
   "hidden": "Locatie verbergen"
  },
  "ui": {
   "title": "Ontdek boerderijen en fokkers",
   "subtitle": "Ontdek de boerderijen en fokkers die Ma Petite Ferme gebruiken om hun activiteit te beheren.",
   "searchPh": "Zoek een boerderij, een stad, een product…",
   "country": "Land",
   "animal": "Type veeteelt",
   "sale": "Verkoopwijze",
   "all": "Alle",
   "mapView": "Bekijk op de kaart",
   "listView": "Bekijk als lijst",
   "discover": "Ontdek de boerderij",
   "verified": "Geverifieerde boerderij",
   "uses": "Gebruikt Ma Petite Ferme",
   "noResults": "Geen boerderij gevonden voor deze zoekopdracht.",
   "prev": "Vorige",
   "next": "Volgende",
   "results": "boerderij(en)",
   "ctaTitle": "Bent u een fokker?",
   "ctaText": "Maak uw gratis openbare pagina aan en sluit u aan bij het netwerk van Europese boerderijen.",
   "ctaBtn": "Mijn boerderij beheren met Ma Petite Ferme",
   "secAbout": "Over ons",
   "secAnimals": "Onze veeteelt",
   "secSale": "Verkoop & distributie",
   "secGallery": "Galerij",
   "secContact": "Contact",
   "secLocation": "Locatie",
   "report": "Deze pagina melden",
   "website": "Website",
   "joinTitle": "Sluit u aan bij de boerderijengids",
   "joinText": "Maak uw gratis openbare pagina aan en vergroot uw zichtbaarheid bij consumenten.",
   "joinBtn": "Mijn openbare pagina aanmaken",
   "navDirectory": "Boerderijen"
  },
  "cat": {
   "browse": "Door de gids bladeren",
   "byCountry": "Per land",
   "byRegion": "Per regio",
   "byType": "Per type veeteelt",
   "byCity": "Per stad",
   "back": "← Terug naar de gids",
   "results": "boerderij(en)",
   "titleType": "Boerderijen {v} in Europa",
   "titleCountry": "Boerderijen in {v}",
   "titleRegion": "Boerderijen in {v}",
   "titleCity": "Boerderijen in {v}",
   "descType": "Ontdek de {v} boerderijen en fokkers die rechtstreeks verkopen op Ma Petite Ferme.",
   "descCountry": "Ontdek de lokale boerderijen en producenten in {v} op de gids van Ma Petite Ferme.",
   "descRegion": "Ontdek de lokale boerderijen en producenten in {v} op de gids van Ma Petite Ferme.",
   "descCity": "Ontdek de lokale boerderijen en producenten in {v} die rechtstreeks verkopen op Ma Petite Ferme.",
   "dirStatsTitle": "Mijn openbare pagina",
   "dirStatsViews": "Profielweergaven",
   "dirStatsWeb": "Websiteklikken",
   "dirStatsPhone": "Telefonische klikken",
   "dirStats30d": "Afgelopen 30 dagen",
   "pdpBack": "← Terug naar de boerderij",
   "pdpOther": "Andere producten van de boerderij",
   "pdpInStock": "Op voorraad",
   "pdpOut": "Uitverkocht",
   "pdpBy": "Verkocht door",
   "pdpHome": "Startpagina",
   "share": "Delen",
   "copied": "Link gekopieerd!",
   "favLogin": "Inloggen",
   "favRegister": "Een account aanmaken",
   "favName": "Naam",
   "favEmail": "E-mail",
   "favPassword": "Wachtwoord",
   "favToRegister": "Nog geen account? Registreren",
   "favToLogin": "Al geregistreerd? Inloggen",
   "favWelcome": "Welkom!",
   "favTitle": "Mijn favoriete boerderijen",
   "favEmpty": "Nog geen favoriete boerderij. Verken de gids en klik op het hartje ❤",
   "favLoginPrompt": "Log in om uw favoriete boerderijen op te slaan en terug te vinden.",
   "favPwdHint": "Minimaal 6 tekens.",
   "fulfillTitle": "Waar u uw producten bij u in de buurt kunt ophalen",
   "fulfillPickup": "{n} boerderij(en) bieden afhalen ter plaatse aan",
   "fulfillDelivery": "{n} boerderij(en) leveren aan huis",
   "fulfillPoints": "Afhaalpunten & steden",
   "faqTitle": "Veelgestelde vragen",
   "relatedTitle": "Ontdek ook"
  }
 },
 "es": {
  "sale": {
   "direct": "Venta directa",
   "market": "Mercado",
   "delivery": "Entrega a domicilio",
   "pickup": "Recogida en el lugar",
   "online": "Tienda en línea",
   "phone": "Pedido por teléfono",
   "email": "Pedido por correo electrónico"
  },
  "precision": {
   "exact": "Dirección exacta",
   "approx": "Dirección aproximada",
   "city": "Solo ciudad",
   "region": "Solo región",
   "hidden": "Ocultar ubicación"
  },
  "ui": {
   "title": "Descubre las granjas y ganaderos",
   "subtitle": "Descubre las granjas y ganaderos que utilizan Ma Petite Ferme para gestionar su actividad.",
   "searchPh": "Buscar una granja, una ciudad, un producto…",
   "country": "País",
   "animal": "Tipo de ganadería",
   "sale": "Modo de venta",
   "all": "Todos",
   "mapView": "Ver en el mapa",
   "listView": "Ver en lista",
   "discover": "Descubrir la granja",
   "verified": "Granja verificada",
   "uses": "Utiliza Ma Petite Ferme",
   "noResults": "No se encontró ninguna granja para esta búsqueda.",
   "prev": "Anterior",
   "next": "Siguiente",
   "results": "granja(s)",
   "ctaTitle": "¿Eres ganadero?",
   "ctaText": "Crea tu página pública gratuita y únete a la red de granjas europeas.",
   "ctaBtn": "Gestionar mi granja con Ma Petite Ferme",
   "secAbout": "Acerca de",
   "secAnimals": "Nuestra ganadería",
   "secSale": "Venta y distribución",
   "secGallery": "Galería",
   "secContact": "Contacto",
   "secLocation": "Ubicación",
   "report": "Reportar esta página",
   "website": "Sitio web",
   "joinTitle": "Únete al directorio de granjas",
   "joinText": "Crea tu página pública gratuita y gana visibilidad entre los consumidores.",
   "joinBtn": "Crear mi página pública",
   "navDirectory": "Granjas"
  },
  "cat": {
   "browse": "Explorar el directorio",
   "byCountry": "Por país",
   "byRegion": "Por región",
   "byType": "Por tipo de ganadería",
   "byCity": "Por ciudad",
   "back": "← Volver al directorio",
   "results": "granja(s)",
   "titleType": "Granjas {v} en Europa",
   "titleCountry": "Granjas en {v}",
   "titleRegion": "Granjas en {v}",
   "titleCity": "Granjas en {v}",
   "descType": "Descubre las granjas y ganaderos {v} que venden directamente en Ma Petite Ferme.",
   "descCountry": "Descubre las granjas y productores locales en {v} en el directorio Ma Petite Ferme.",
   "descRegion": "Descubre las granjas y productores locales en {v} en el directorio Ma Petite Ferme.",
   "descCity": "Descubre las granjas y productores locales en {v} que venden directamente en Ma Petite Ferme.",
   "dirStatsTitle": "Mi página pública",
   "dirStatsViews": "Visitas al perfil",
   "dirStatsWeb": "Clics en el sitio web",
   "dirStatsPhone": "Clics en el teléfono",
   "dirStats30d": "Últimos 30 días",
   "pdpBack": "← Volver a la granja",
   "pdpOther": "Otros productos de la granja",
   "pdpInStock": "En stock",
   "pdpOut": "Agotado",
   "pdpBy": "Vendido por",
   "pdpHome": "Inicio",
   "share": "Compartir",
   "copied": "¡Enlace copiado!",
   "favLogin": "Iniciar sesión",
   "favRegister": "Crear una cuenta",
   "favName": "Nombre",
   "favEmail": "Correo electrónico",
   "favPassword": "Contraseña",
   "favToRegister": "¿Aún no tienes cuenta? Regístrate",
   "favToLogin": "¿Ya tienes cuenta? Iniciar sesión",
   "favWelcome": "¡Bienvenido!",
   "favTitle": "Mis granjas favoritas",
   "favEmpty": "Ninguna granja en favoritos por el momento. Explora el directorio y haz clic en el corazón ❤",
   "favLoginPrompt": "Inicia sesión para guardar y encontrar tus granjas favoritas.",
   "favPwdHint": "Mínimo 6 caracteres.",
   "fulfillTitle": "Dónde recoger tus productos cerca de ti",
   "fulfillPickup": "{n} granja(s) ofrecen recogida en el lugar",
   "fulfillDelivery": "{n} granja(s) entregan a domicilio",
   "fulfillPoints": "Puntos de recogida y ciudades",
   "faqTitle": "Preguntas frecuentes",
   "relatedTitle": "Explora también"
  }
 },
 "it": {
  "sale": {
   "direct": "Vendita diretta",
   "market": "Mercato",
   "delivery": "Consegna a domicilio",
   "pickup": "Ritiro in loco",
   "online": "Negozio online",
   "phone": "Ordine per telefono",
   "email": "Ordine per email"
  },
  "precision": {
   "exact": "Indirizzo esatto",
   "approx": "Indirizzo approssimativo",
   "city": "Solo città",
   "region": "Solo regione",
   "hidden": "Nascondi la posizione"
  },
  "ui": {
   "title": "Scopri le fattorie e gli allevatori",
   "subtitle": "Scopri le fattorie e gli allevatori che utilizzano Ma Petite Ferme per gestire la loro attività.",
   "searchPh": "Cerca una fattoria, una città, un prodotto…",
   "country": "Paese",
   "animal": "Tipo di allevamento",
   "sale": "Modalità di vendita",
   "all": "Tutti",
   "mapView": "Vedi sulla mappa",
   "listView": "Vedi in elenco",
   "discover": "Scopri la fattoria",
   "verified": "Fattoria verificata",
   "uses": "Utilizza Ma Petite Ferme",
   "noResults": "Nessuna fattoria trovata per questa ricerca.",
   "prev": "Precedente",
   "next": "Successivo",
   "results": "fattoria(e)",
   "ctaTitle": "Sei un allevatore?",
   "ctaText": "Crea la tua pagina pubblica gratuita e unisciti alla rete delle fattorie europee.",
   "ctaBtn": "Gestisci la mia fattoria con Ma Petite Ferme",
   "secAbout": "Chi siamo",
   "secAnimals": "Il nostro allevamento",
   "secSale": "Vendita e distribuzione",
   "secGallery": "Galleria",
   "secContact": "Contatto",
   "secLocation": "Posizione",
   "report": "Segnala questa pagina",
   "website": "Sito internet",
   "joinTitle": "Unisciti all'elenco delle fattorie",
   "joinText": "Crea la tua pagina pubblica gratuita e aumenta la tua visibilità presso i consumatori.",
   "joinBtn": "Crea la mia pagina pubblica",
   "navDirectory": "Fattorie"
  },
  "cat": {
   "browse": "Sfoglia l'elenco",
   "byCountry": "Per paese",
   "byRegion": "Per regione",
   "byType": "Per tipo di allevamento",
   "byCity": "Per città",
   "back": "← Torna all'elenco",
   "results": "fattoria(e)",
   "titleType": "Fattorie {v} in Europa",
   "titleCountry": "Fattorie in {v}",
   "titleRegion": "Fattorie in {v}",
   "titleCity": "Fattorie a {v}",
   "descType": "Scopri le fattorie e gli allevatori {v} che vendono direttamente su Ma Petite Ferme.",
   "descCountry": "Scopri le fattorie e i produttori locali in {v} sull'elenco Ma Petite Ferme.",
   "descRegion": "Scopri le fattorie e i produttori locali in {v} sull'elenco Ma Petite Ferme.",
   "descCity": "Scopri le fattorie e i produttori locali a {v} che vendono direttamente su Ma Petite Ferme.",
   "dirStatsTitle": "La mia pagina pubblica",
   "dirStatsViews": "Visualizzazioni del profilo",
   "dirStatsWeb": "Clic sul sito web",
   "dirStatsPhone": "Clic sul telefono",
   "dirStats30d": "Ultimi 30 giorni",
   "pdpBack": "← Torna alla fattoria",
   "pdpOther": "Altri prodotti della fattoria",
   "pdpInStock": "Disponibile",
   "pdpOut": "Esaurito",
   "pdpBy": "Venduto da",
   "pdpHome": "Home",
   "share": "Condividi",
   "copied": "Link copiato!",
   "favLogin": "Accedi",
   "favRegister": "Crea un account",
   "favName": "Nome",
   "favEmail": "E-mail",
   "favPassword": "Password",
   "favToRegister": "Non hai ancora un account? Registrati",
   "favToLogin": "Hai già un account? Accedi",
   "favWelcome": "Benvenuto!",
   "favTitle": "Le mie fattorie preferite",
   "favEmpty": "Nessuna fattoria tra i preferiti per ora. Esplora l'elenco e clicca sul cuore ❤",
   "favLoginPrompt": "Accedi per salvare e ritrovare le tue fattorie preferite.",
   "favPwdHint": "Minimo 6 caratteri.",
   "fulfillTitle": "Dove ritirare i tuoi prodotti vicino a te",
   "fulfillPickup": "{n} fattoria(e) propongono il ritiro in loco",
   "fulfillDelivery": "{n} fattoria(e) consegnano a domicilio",
   "fulfillPoints": "Punti di ritiro e città",
   "faqTitle": "Domande frequenti",
   "relatedTitle": "Esplora anche"
  }
 },
 "de": {
  "sale": {
   "direct": "Direktverkauf",
   "market": "Markt",
   "delivery": "Lieferung",
   "pickup": "Abholung vor Ort",
   "online": "Online-Shop",
   "phone": "Bestellung per Telefon",
   "email": "Bestellung per E-Mail"
  },
  "precision": {
   "exact": "Genaue Adresse",
   "approx": "Ungefähre Adresse",
   "city": "Nur Stadt",
   "region": "Nur Region",
   "hidden": "Standort verbergen"
  },
  "ui": {
   "title": "Entdecken Sie Höfe und Züchter",
   "subtitle": "Entdecken Sie die Höfe und Züchter, die Ma Petite Ferme zur Verwaltung ihrer Aktivitäten nutzen.",
   "searchPh": "Einen Hof, eine Stadt, ein Produkt suchen…",
   "country": "Land",
   "animal": "Art der Tierhaltung",
   "sale": "Verkaufsart",
   "all": "Alle",
   "mapView": "Auf der Karte anzeigen",
   "listView": "Als Liste anzeigen",
   "discover": "Den Hof entdecken",
   "verified": "Verifizierter Hof",
   "uses": "Nutzt Ma Petite Ferme",
   "noResults": "Kein Hof für diese Suche gefunden.",
   "prev": "Zurück",
   "next": "Weiter",
   "results": "Hof/Höfe",
   "ctaTitle": "Sie sind Züchter?",
   "ctaText": "Erstellen Sie Ihre kostenlose öffentliche Seite und treten Sie dem Netzwerk europäischer Höfe bei.",
   "ctaBtn": "Meinen Hof mit Ma Petite Ferme verwalten",
   "secAbout": "Über uns",
   "secAnimals": "Unsere Tierhaltung",
   "secSale": "Verkauf & Vertrieb",
   "secGallery": "Galerie",
   "secContact": "Kontakt",
   "secLocation": "Standort",
   "report": "Diese Seite melden",
   "website": "Website",
   "joinTitle": "Treten Sie dem Hofverzeichnis bei",
   "joinText": "Erstellen Sie Ihre kostenlose öffentliche Seite und gewinnen Sie mehr Sichtbarkeit bei Verbrauchern.",
   "joinBtn": "Meine öffentliche Seite erstellen",
   "navDirectory": "Höfe"
  },
  "cat": {
   "browse": "Verzeichnis durchsuchen",
   "byCountry": "Nach Land",
   "byRegion": "Nach Region",
   "byType": "Nach Art der Tierhaltung",
   "byCity": "Nach Stadt",
   "back": "← Zurück zum Verzeichnis",
   "results": "Hof/Höfe",
   "titleType": "Höfe {v} in Europa",
   "titleCountry": "Höfe in {v}",
   "titleRegion": "Höfe in {v}",
   "titleCity": "Höfe in {v}",
   "descType": "Entdecken Sie die {v} Höfe und Züchter, die direkt über Ma Petite Ferme verkaufen.",
   "descCountry": "Entdecken Sie lokale Höfe und Erzeuger in {v} im Verzeichnis Ma Petite Ferme.",
   "descRegion": "Entdecken Sie lokale Höfe und Erzeuger in {v} im Verzeichnis Ma Petite Ferme.",
   "descCity": "Entdecken Sie lokale Höfe und Erzeuger in {v}, die direkt über Ma Petite Ferme verkaufen.",
   "dirStatsTitle": "Meine öffentliche Seite",
   "dirStatsViews": "Profilaufrufe",
   "dirStatsWeb": "Website-Klicks",
   "dirStatsPhone": "Telefon-Klicks",
   "dirStats30d": "Letzte 30 Tage",
   "pdpBack": "← Zurück zum Hof",
   "pdpOther": "Weitere Produkte des Hofes",
   "pdpInStock": "Auf Lager",
   "pdpOut": "Nicht vorrätig",
   "pdpBy": "Verkauft von",
   "pdpHome": "Startseite",
   "share": "Teilen",
   "copied": "Link kopiert!",
   "favLogin": "Anmelden",
   "favRegister": "Konto erstellen",
   "favName": "Name",
   "favEmail": "E-Mail",
   "favPassword": "Passwort",
   "favToRegister": "Noch kein Konto? Registrieren",
   "favToLogin": "Bereits registriert? Anmelden",
   "favWelcome": "Willkommen!",
   "favTitle": "Meine Lieblingshöfe",
   "favEmpty": "Noch keine Lieblingshöfe gespeichert. Stöbern Sie im Verzeichnis und klicken Sie auf das Herz ❤",
   "favLoginPrompt": "Melden Sie sich an, um Ihre Lieblingshöfe zu speichern und wiederzufinden.",
   "favPwdHint": "Mindestens 6 Zeichen.",
   "fulfillTitle": "Wo Sie Ihre Produkte in Ihrer Nähe abholen können",
   "fulfillPickup": "{n} Hof/Höfe bieten Abholung vor Ort an",
   "fulfillDelivery": "{n} Hof/Höfe liefern nach Hause",
   "fulfillPoints": "Abholpunkte & Städte",
   "faqTitle": "Häufig gestellte Fragen",
   "relatedTitle": "Entdecken Sie auch"
  }
 },
 "sv": {
  "sale": {
   "direct": "Direktförsäljning",
   "market": "Marknad",
   "delivery": "Leverans",
   "pickup": "Avhämtning på plats",
   "online": "Nätbutik",
   "phone": "Beställning per telefon",
   "email": "Beställning per e-post"
  },
  "precision": {
   "exact": "Exakt adress",
   "approx": "Ungefärlig adress",
   "city": "Endast stad",
   "region": "Endast region",
   "hidden": "Dölj platsen"
  },
  "ui": {
   "title": "Upptäck gårdar och uppfödare",
   "subtitle": "Upptäck gårdar och uppfödare som använder Ma Petite Ferme för att sköta sin verksamhet.",
   "searchPh": "Sök efter en gård, en stad, en produkt…",
   "country": "Land",
   "animal": "Typ av uppfödning",
   "sale": "Försäljningssätt",
   "all": "Alla",
   "mapView": "Visa på kartan",
   "listView": "Visa som lista",
   "discover": "Upptäck gården",
   "verified": "Verifierad gård",
   "uses": "Använder Ma Petite Ferme",
   "noResults": "Inga gårdar hittades för denna sökning.",
   "prev": "Föregående",
   "next": "Nästa",
   "results": "gård(ar)",
   "ctaTitle": "Är du uppfödare?",
   "ctaText": "Skapa din kostnadsfria offentliga sida och gå med i nätverket av europeiska gårdar.",
   "ctaBtn": "Hantera min gård med Ma Petite Ferme",
   "secAbout": "Om oss",
   "secAnimals": "Vår uppfödning",
   "secSale": "Försäljning & distribution",
   "secGallery": "Galleri",
   "secContact": "Kontakt",
   "secLocation": "Plats",
   "report": "Rapportera den här sidan",
   "website": "Webbplats",
   "joinTitle": "Gå med i gårdsregistret",
   "joinText": "Skapa din kostnadsfria offentliga sida och öka din synlighet hos konsumenter.",
   "joinBtn": "Skapa min offentliga sida",
   "navDirectory": "Gårdar"
  },
  "cat": {
   "browse": "Bläddra i registret",
   "byCountry": "Per land",
   "byRegion": "Per region",
   "byType": "Per typ av uppfödning",
   "byCity": "Per stad",
   "back": "← Tillbaka till registret",
   "results": "gård(ar)",
   "titleType": "Gårdar {v} i Europa",
   "titleCountry": "Gårdar i {v}",
   "titleRegion": "Gårdar i {v}",
   "titleCity": "Gårdar i {v}",
   "descType": "Upptäck gårdar och uppfödare {v} som säljer direkt på Ma Petite Ferme.",
   "descCountry": "Upptäck lokala gårdar och producenter i {v} i Ma Petite Fermes register.",
   "descRegion": "Upptäck lokala gårdar och producenter i {v} i Ma Petite Fermes register.",
   "descCity": "Upptäck lokala gårdar och producenter i {v} som säljer direkt på Ma Petite Ferme.",
   "dirStatsTitle": "Min offentliga sida",
   "dirStatsViews": "Profilvisningar",
   "dirStatsWeb": "Klick på webbplats",
   "dirStatsPhone": "Klick på telefon",
   "dirStats30d": "Senaste 30 dagarna",
   "pdpBack": "← Tillbaka till gården",
   "pdpOther": "Andra produkter från gården",
   "pdpInStock": "I lager",
   "pdpOut": "Slut i lager",
   "pdpBy": "Säljs av",
   "pdpHome": "Hem",
   "share": "Dela",
   "copied": "Länk kopierad!",
   "favLogin": "Logga in",
   "favRegister": "Skapa ett konto",
   "favName": "Namn",
   "favEmail": "E-post",
   "favPassword": "Lösenord",
   "favToRegister": "Inget konto än? Registrera dig",
   "favToLogin": "Redan registrerad? Logga in",
   "favWelcome": "Välkommen!",
   "favTitle": "Mina favoritgårdar",
   "favEmpty": "Inga favoritgårdar ännu. Utforska registret och klicka på hjärtat ❤",
   "favLoginPrompt": "Logga in för att spara och hitta dina favoritgårdar.",
   "favPwdHint": "Minst 6 tecken.",
   "fulfillTitle": "Var du hämtar dina produkter nära dig",
   "fulfillPickup": "{n} gård(ar) erbjuder avhämtning på plats",
   "fulfillDelivery": "{n} gård(ar) levererar hem till dig",
   "fulfillPoints": "Avhämtningsställen & städer",
   "faqTitle": "Vanliga frågor",
   "relatedTitle": "Utforska också"
  }
 },
 "da": {
  "sale": {
   "direct": "Direkte salg",
   "market": "Marked",
   "delivery": "Levering",
   "pickup": "Afhentning på stedet",
   "online": "Netbutik",
   "phone": "Bestilling pr. telefon",
   "email": "Bestilling pr. e-mail"
  },
  "precision": {
   "exact": "Præcis adresse",
   "approx": "Omtrentlig adresse",
   "city": "Kun by",
   "region": "Kun region",
   "hidden": "Skjul placering"
  },
  "ui": {
   "title": "Opdag gårde og opdrættere",
   "subtitle": "Opdag de gårde og opdrættere, der bruger Ma Petite Ferme til at administrere deres virksomhed.",
   "searchPh": "Søg efter en gård, en by, et produkt…",
   "country": "Land",
   "animal": "Type opdræt",
   "sale": "Salgsmetode",
   "all": "Alle",
   "mapView": "Se på kortet",
   "listView": "Se som liste",
   "discover": "Opdag gården",
   "verified": "Verificeret gård",
   "uses": "Bruger Ma Petite Ferme",
   "noResults": "Ingen gårde fundet for denne søgning.",
   "prev": "Forrige",
   "next": "Næste",
   "results": "gård(e)",
   "ctaTitle": "Er du opdrætter?",
   "ctaText": "Opret din gratis offentlige side og tilslut dig netværket af europæiske gårde.",
   "ctaBtn": "Administrer min gård med Ma Petite Ferme",
   "secAbout": "Om os",
   "secAnimals": "Vores opdræt",
   "secSale": "Salg & distribution",
   "secGallery": "Galleri",
   "secContact": "Kontakt",
   "secLocation": "Placering",
   "report": "Anmeld denne side",
   "website": "Hjemmeside",
   "joinTitle": "Tilslut dig gårdsfortegnelsen",
   "joinText": "Opret din gratis offentlige side og bliv mere synlig over for forbrugerne.",
   "joinBtn": "Opret min offentlige side",
   "navDirectory": "Gårde"
  },
  "cat": {
   "browse": "Gennemse fortegnelsen",
   "byCountry": "Efter land",
   "byRegion": "Efter region",
   "byType": "Efter opdrætstype",
   "byCity": "Efter by",
   "back": "← Tilbage til fortegnelsen",
   "results": "gård(e)",
   "titleType": "Gårde {v} i Europa",
   "titleCountry": "Gårde i {v}",
   "titleRegion": "Gårde i {v}",
   "titleCity": "Gårde i {v}",
   "descType": "Opdag {v} gårde og opdrættere, der sælger direkte på Ma Petite Ferme.",
   "descCountry": "Opdag lokale gårde og producenter i {v} i Ma Petite Fermes fortegnelse.",
   "descRegion": "Opdag lokale gårde og producenter i {v} i Ma Petite Fermes fortegnelse.",
   "descCity": "Opdag lokale gårde og producenter i {v}, der sælger direkte på Ma Petite Ferme.",
   "dirStatsTitle": "Min offentlige side",
   "dirStatsViews": "Profilvisninger",
   "dirStatsWeb": "Klik på hjemmeside",
   "dirStatsPhone": "Klik på telefon",
   "dirStats30d": "Seneste 30 dage",
   "pdpBack": "← Tilbage til gården",
   "pdpOther": "Andre produkter fra gården",
   "pdpInStock": "På lager",
   "pdpOut": "Ikke på lager",
   "pdpBy": "Solgt af",
   "pdpHome": "Forside",
   "share": "Del",
   "copied": "Link kopieret!",
   "favLogin": "Log ind",
   "favRegister": "Opret en konto",
   "favName": "Navn",
   "favEmail": "E-mail",
   "favPassword": "Adgangskode",
   "favToRegister": "Endnu ingen konto? Tilmeld dig",
   "favToLogin": "Allerede registreret? Log ind",
   "favWelcome": "Velkommen!",
   "favTitle": "Mine foretrukne gårde",
   "favEmpty": "Ingen foretrukne gårde endnu. Udforsk fortegnelsen og klik på hjertet ❤",
   "favLoginPrompt": "Log ind for at gemme og finde dine foretrukne gårde.",
   "favPwdHint": "Minimum 6 tegn.",
   "fulfillTitle": "Hvor du kan hente dine produkter i nærheden",
   "fulfillPickup": "{n} gård(e) tilbyder afhentning på stedet",
   "fulfillDelivery": "{n} gård(e) leverer til hjemadressen",
   "fulfillPoints": "Afhentningssteder & byer",
   "faqTitle": "Ofte stillede spørgsmål",
   "relatedTitle": "Udforsk også"
  }
 },
 "bg": {
  "sale": {
   "direct": "Директна продажба",
   "market": "Пазар",
   "delivery": "Доставка",
   "pickup": "Вземане на място",
   "online": "Онлайн магазин",
   "phone": "Поръчка по телефон",
   "email": "Поръчка по имейл"
  },
  "precision": {
   "exact": "Точен адрес",
   "approx": "Приблизителен адрес",
   "city": "Само град",
   "region": "Само регион",
   "hidden": "Скриване на местоположението"
  },
  "ui": {
   "title": "Открийте ферми и животновъди",
   "subtitle": "Открийте фермите и животновъдите, които използват Ma Petite Ferme за управление на дейността си.",
   "searchPh": "Търсене на ферма, град, продукт…",
   "country": "Държава",
   "animal": "Вид животновъдство",
   "sale": "Начин на продажба",
   "all": "Всички",
   "mapView": "Виж на картата",
   "listView": "Виж като списък",
   "discover": "Открий фермата",
   "verified": "Верифицирана ферма",
   "uses": "Използва Ma Petite Ferme",
   "noResults": "Не са намерени ферми за това търсене.",
   "prev": "Предишна",
   "next": "Следваща",
   "results": "ферма(и)",
   "ctaTitle": "Вие сте животновъд?",
   "ctaText": "Създайте безплатна публична страница и се присъединете към мрежата на европейските ферми.",
   "ctaBtn": "Управлявай фермата си с Ma Petite Ferme",
   "secAbout": "За нас",
   "secAnimals": "Нашето животновъдство",
   "secSale": "Продажба и дистрибуция",
   "secGallery": "Галерия",
   "secContact": "Контакт",
   "secLocation": "Местоположение",
   "report": "Докладвай тази страница",
   "website": "Уебсайт",
   "joinTitle": "Присъединете се към указателя на ферми",
   "joinText": "Създайте безплатна публична страница и спечелете видимост сред потребителите.",
   "joinBtn": "Създай моята публична страница",
   "navDirectory": "Ферми"
  },
  "cat": {
   "browse": "Разгледай указателя",
   "byCountry": "По държава",
   "byRegion": "По регион",
   "byType": "По вид животновъдство",
   "byCity": "По град",
   "back": "← Обратно към указателя",
   "results": "ферма(и)",
   "titleType": "Ферми {v} в Европа",
   "titleCountry": "Ферми в {v}",
   "titleRegion": "Ферми в {v}",
   "titleCity": "Ферми в {v}",
   "descType": "Открийте фермите и животновъдите {v}, които продават директно в Ma Petite Ferme.",
   "descCountry": "Открийте местните ферми и производители в {v} в указателя на Ma Petite Ferme.",
   "descRegion": "Открийте местните ферми и производители в {v} в указателя на Ma Petite Ferme.",
   "descCity": "Открийте местните ферми и производители в {v}, които продават директно в Ma Petite Ferme.",
   "dirStatsTitle": "Моята публична страница",
   "dirStatsViews": "Прегледи на профила",
   "dirStatsWeb": "Кликвания към уебсайт",
   "dirStatsPhone": "Кликвания към телефон",
   "dirStats30d": "Последните 30 дни",
   "pdpBack": "← Обратно към фермата",
   "pdpOther": "Други продукти от фермата",
   "pdpInStock": "В наличност",
   "pdpOut": "Изчерпано",
   "pdpBy": "Продавано от",
   "pdpHome": "Начало",
   "share": "Споделяне",
   "copied": "Връзката е копирана!",
   "favLogin": "Вход",
   "favRegister": "Създай акаунт",
   "favName": "Име",
   "favEmail": "Имейл",
   "favPassword": "Парола",
   "favToRegister": "Нямате акаунт? Регистрирайте се",
   "favToLogin": "Вече сте регистриран? Влезте",
   "favWelcome": "Добре дошли!",
   "favTitle": "Моите любими ферми",
   "favEmpty": "Все още няма любими ферми. Разгледайте указателя и кликнете на сърцето ❤",
   "favLoginPrompt": "Влезте в акаунта си, за да запазите и намерите любимите си ферми.",
   "favPwdHint": "Минимум 6 знака.",
   "fulfillTitle": "Къде да вземете продуктите си близо до вас",
   "fulfillPickup": "{n} ферма(и) предлагат вземане на място",
   "fulfillDelivery": "{n} ферма(и) доставят до дома",
   "fulfillPoints": "Точки за вземане и градове",
   "faqTitle": "Често задавани въпроси",
   "relatedTitle": "Разгледайте също"
  }
 },
 "el": {
  "sale": {
   "direct": "Άμεση πώληση",
   "market": "Αγορά",
   "delivery": "Παράδοση",
   "pickup": "Παραλαβή επί τόπου",
   "online": "Ηλεκτρονικό κατάστημα",
   "phone": "Παραγγελία τηλεφωνικά",
   "email": "Παραγγελία μέσω email"
  },
  "precision": {
   "exact": "Ακριβής διεύθυνση",
   "approx": "Κατά προσέγγιση διεύθυνση",
   "city": "Μόνο πόλη",
   "region": "Μόνο περιοχή",
   "hidden": "Απόκρυψη τοποθεσίας"
  },
  "ui": {
   "title": "Ανακαλύψτε αγροκτήματα και κτηνοτρόφους",
   "subtitle": "Ανακαλύψτε τα αγροκτήματα και τους κτηνοτρόφους που χρησιμοποιούν Ma Petite Ferme για τη διαχείριση της δραστηριότητάς τους.",
   "searchPh": "Αναζήτηση αγροκτήματος, πόλης, προϊόντος…",
   "country": "Χώρα",
   "animal": "Τύπος κτηνοτροφίας",
   "sale": "Τρόπος πώλησης",
   "all": "Όλα",
   "mapView": "Προβολή στον χάρτη",
   "listView": "Προβολή σε λίστα",
   "discover": "Ανακαλύψτε το αγρόκτημα",
   "verified": "Επαληθευμένο αγρόκτημα",
   "uses": "Χρησιμοποιεί το Ma Petite Ferme",
   "noResults": "Δεν βρέθηκε κανένα αγρόκτημα για αυτή την αναζήτηση.",
   "prev": "Προηγούμενο",
   "next": "Επόμενο",
   "results": "αγρόκτημα(-τα)",
   "ctaTitle": "Είστε κτηνοτρόφος;",
   "ctaText": "Δημιουργήστε τη δωρεάν δημόσια σελίδα σας και εντάξτε το δίκτυο ευρωπαϊκών αγροκτημάτων.",
   "ctaBtn": "Διαχείριση της φάρμας μου με Ma Petite Ferme",
   "secAbout": "Σχετικά",
   "secAnimals": "Η κτηνοτροφία μας",
   "secSale": "Πώληση & διανομή",
   "secGallery": "Γκαλερί",
   "secContact": "Επικοινωνία",
   "secLocation": "Τοποθεσία",
   "report": "Αναφορά αυτής της σελίδας",
   "website": "Ιστοσελίδα",
   "joinTitle": "Εγγραφείτε στον κατάλογο αγροκτημάτων",
   "joinText": "Δημιουργήστε τη δωρεάν δημόσια σελίδα σας και αποκτήστε μεγαλύτερη ορατότητα στους καταναλωτές.",
   "joinBtn": "Δημιουργία δημόσιας σελίδας μου",
   "navDirectory": "Αγροκτήματα"
  },
  "cat": {
   "browse": "Περιήγηση στον κατάλογο",
   "byCountry": "Ανά χώρα",
   "byRegion": "Ανά περιοχή",
   "byType": "Ανά τύπο κτηνοτροφίας",
   "byCity": "Ανά πόλη",
   "back": "← Επιστροφή στον κατάλογο",
   "results": "αγρόκτημα(-τα)",
   "titleType": "Αγροκτήματα {v} στην Ευρώπη",
   "titleCountry": "Αγροκτήματα στη {v}",
   "titleRegion": "Αγροκτήματα στη {v}",
   "titleCity": "Αγροκτήματα στη {v}",
   "descType": "Ανακαλύψτε τα αγροκτήματα και τους κτηνοτρόφους {v} που πωλούν απευθείας στο Ma Petite Ferme.",
   "descCountry": "Ανακαλύψτε τα αγροκτήματα και τους τοπικούς παραγωγούς στη {v} στον κατάλογο Ma Petite Ferme.",
   "descRegion": "Ανακαλύψτε τα αγροκτήματα και τους τοπικούς παραγωγούς στη {v} στον κατάλογο Ma Petite Ferme.",
   "descCity": "Ανακαλύψτε τα αγροκτήματα και τους τοπικούς παραγωγούς στη {v} που πωλούν απευθείας στο Ma Petite Ferme.",
   "dirStatsTitle": "Η δημόσια σελίδα μου",
   "dirStatsViews": "Προβολές προφίλ",
   "dirStatsWeb": "Κλικ ιστοσελίδας",
   "dirStatsPhone": "Κλικ τηλεφώνου",
   "dirStats30d": "Τελευταίες 30 ημέρες",
   "pdpBack": "← Επιστροφή στο αγρόκτημα",
   "pdpOther": "Άλλα προϊόντα του αγροκτήματος",
   "pdpInStock": "Σε απόθεμα",
   "pdpOut": "Εξαντλημένο",
   "pdpBy": "Πωλείται από",
   "pdpHome": "Αρχική",
   "share": "Κοινοποίηση",
   "copied": "Ο σύνδεσμος αντιγράφηκε!",
   "favLogin": "Σύνδεση",
   "favRegister": "Δημιουργία λογαριασμού",
   "favName": "Όνομα",
   "favEmail": "E-mail",
   "favPassword": "Κωδικός πρόσβασης",
   "favToRegister": "Δεν έχετε λογαριασμό; Εγγραφείτε",
   "favToLogin": "Έχετε ήδη λογαριασμό; Συνδεθείτε",
   "favWelcome": "Καλώς ορίσατε!",
   "favTitle": "Αγαπημένα αγροκτήματά μου",
   "favEmpty": "Δεν υπάρχουν αγαπημένα αγροκτήματα προς το παρόν. Εξερευνήστε τον κατάλογο και κάντε κλικ στην καρδιά ❤",
   "favLoginPrompt": "Συνδεθείτε για να αποθηκεύσετε και να βρείτε τα αγαπημένα σας αγροκτήματα.",
   "favPwdHint": "Τουλάχιστον 6 χαρακτήρες.",
   "fulfillTitle": "Πού να παραλάβετε τα προϊόντα σας κοντά σας",
   "fulfillPickup": "{n} αγρόκτημα(-τα) προσφέρουν παραλαβή επί τόπου",
   "fulfillDelivery": "{n} αγρόκτημα(-τα) παραδίδουν κατ' οίκον",
   "fulfillPoints": "Σημεία παραλαβής & πόλεις",
   "faqTitle": "Συχνές ερωτήσεις",
   "relatedTitle": "Εξερευνήστε επίσης"
  }
 },
 "hr": {
  "sale": {
   "direct": "Izravna prodaja",
   "market": "Tržnica",
   "delivery": "Dostava",
   "pickup": "Preuzimanje na licu mjesta",
   "online": "Online trgovina",
   "phone": "Narudžba telefonom",
   "email": "Narudžba e-poštom"
  },
  "precision": {
   "exact": "Točna adresa",
   "approx": "Približna adresa",
   "city": "Samo grad",
   "region": "Samo regija",
   "hidden": "Sakrij lokaciju"
  },
  "ui": {
   "title": "Otkrijte farme i uzgajivače",
   "subtitle": "Otkrijte farme i uzgajivače koji koriste Ma Petite Ferme za upravljanje svojom djelatnošću.",
   "searchPh": "Pretraži farmu, grad, proizvod…",
   "country": "Zemlja",
   "animal": "Vrsta uzgoja",
   "sale": "Način prodaje",
   "all": "Sve",
   "mapView": "Pogledaj na karti",
   "listView": "Pogledaj kao popis",
   "discover": "Otkrij farmu",
   "verified": "Verificirana farma",
   "uses": "Koristi Ma Petite Ferme",
   "noResults": "Nije pronađena nijedna farma za ovaj upit.",
   "prev": "Prethodno",
   "next": "Sljedeće",
   "results": "farma",
   "ctaTitle": "Jeste li uzgajivač?",
   "ctaText": "Izradite svoju besplatnu javnu stranicu i pridružite se mreži europskih farmi.",
   "ctaBtn": "Upravljaj mojom farmom s Ma Petite Ferme",
   "secAbout": "O nama",
   "secAnimals": "Naš uzgoj",
   "secSale": "Prodaja i distribucija",
   "secGallery": "Galerija",
   "secContact": "Kontakt",
   "secLocation": "Lokacija",
   "report": "Prijavi ovu stranicu",
   "website": "Web stranica",
   "joinTitle": "Pridružite se imeniku farmi",
   "joinText": "Izradite svoju besplatnu javnu stranicu i povećajte vidljivost kod potrošača.",
   "joinBtn": "Izradi moju javnu stranicu",
   "navDirectory": "Farme"
  },
  "cat": {
   "browse": "Pregledaj imenik",
   "byCountry": "Po zemlji",
   "byRegion": "Po regiji",
   "byType": "Po vrsti uzgoja",
   "byCity": "Po gradu",
   "back": "← Povratak na imenik",
   "results": "farma",
   "titleType": "Farme {v} u Europi",
   "titleCountry": "Farme u {v}",
   "titleRegion": "Farme u {v}",
   "titleCity": "Farme u {v}",
   "descType": "Otkrijte farme i uzgajivače {v} koji prodaju izravno na Ma Petite Ferme.",
   "descCountry": "Otkrijte lokalne farme i proizvođače u {v} na imeniku Ma Petite Ferme.",
   "descRegion": "Otkrijte lokalne farme i proizvođače u {v} na imeniku Ma Petite Ferme.",
   "descCity": "Otkrijte lokalne farme i proizvođače u {v} koji prodaju izravno na Ma Petite Ferme.",
   "dirStatsTitle": "Moja javna stranica",
   "dirStatsViews": "Pregledi profila",
   "dirStatsWeb": "Klikovi na web stranicu",
   "dirStatsPhone": "Klikovi na telefon",
   "dirStats30d": "Posljednjih 30 dana",
   "pdpBack": "← Povratak na farmu",
   "pdpOther": "Drugi proizvodi farme",
   "pdpInStock": "Na zalihi",
   "pdpOut": "Nema na zalihi",
   "pdpBy": "Prodaje",
   "pdpHome": "Početna",
   "share": "Podijeli",
   "copied": "Veza kopirana!",
   "favLogin": "Prijava",
   "favRegister": "Izradi račun",
   "favName": "Ime",
   "favEmail": "E-pošta",
   "favPassword": "Lozinka",
   "favToRegister": "Nemate račun? Registrirajte se",
   "favToLogin": "Već ste registrirani? Prijavite se",
   "favWelcome": "Dobrodošli!",
   "favTitle": "Moje omiljene farme",
   "favEmpty": "Trenutno nema omiljenih farmi. Istražite imenik i kliknite na srce ❤",
   "favLoginPrompt": "Prijavite se kako biste spremili i pronašli svoje omiljene farme.",
   "favPwdHint": "Najmanje 6 znakova.",
   "fulfillTitle": "Gdje preuzeti vaše proizvode u blizini",
   "fulfillPickup": "{n} farma(e) nude preuzimanje na licu mjesta",
   "fulfillDelivery": "{n} farma(e) dostavljaju na kućnu adresu",
   "fulfillPoints": "Mjesta preuzimanja i gradovi",
   "faqTitle": "Često postavljana pitanja",
   "relatedTitle": "Istražite i ovo"
  }
 },
 "et": {
  "sale": {
   "direct": "Otsemüük",
   "market": "Turg",
   "delivery": "Kohaletoimetamine",
   "pickup": "Kättesaamine kohapeal",
   "online": "Veebiturg",
   "phone": "Tellimine telefoni teel",
   "email": "Tellimine e-posti teel"
  },
  "precision": {
   "exact": "Täpne aadress",
   "approx": "Ligikaudne aadress",
   "city": "Ainult linn",
   "region": "Ainult piirkond",
   "hidden": "Peida asukoht"
  },
  "ui": {
   "title": "Avastage talud ja kasvatajad",
   "subtitle": "Avastage talud ja kasvatajad, kes kasutavad Ma Petite Ferme oma tegevuse haldamiseks.",
   "searchPh": "Otsi talu, linna, toodet…",
   "country": "Riik",
   "animal": "Kasvatuse tüüp",
   "sale": "Müügiviis",
   "all": "Kõik",
   "mapView": "Vaata kaardil",
   "listView": "Vaata loendina",
   "discover": "Avasta talu",
   "verified": "Kinnitatud talu",
   "uses": "Kasutab Ma Petite Ferme",
   "noResults": "Selle otsingu jaoks ei leitud ühtegi talu.",
   "prev": "Eelmine",
   "next": "Järgmine",
   "results": "talu(d)",
   "ctaTitle": "Olete kasvataja?",
   "ctaText": "Looge oma tasuta avalik leht ja liituge Euroopa talude võrgustikuga.",
   "ctaBtn": "Halda oma talu Ma Petite Ferme abil",
   "secAbout": "Meist",
   "secAnimals": "Meie kasvatus",
   "secSale": "Müük ja jaotus",
   "secGallery": "Galerii",
   "secContact": "Kontakt",
   "secLocation": "Asukoht",
   "report": "Teata sellest lehest",
   "website": "Veebisait",
   "joinTitle": "Liituge talude kataloogiga",
   "joinText": "Looge oma tasuta avalik leht ja suurendage oma nähtavust tarbijate seas.",
   "joinBtn": "Loo minu avalik leht",
   "navDirectory": "Talud"
  },
  "cat": {
   "browse": "Sirvi kataloogi",
   "byCountry": "Riigi järgi",
   "byRegion": "Piirkonna järgi",
   "byType": "Kasvatuse tüübi järgi",
   "byCity": "Linna järgi",
   "back": "← Tagasi kataloogi",
   "results": "talu(d)",
   "titleType": "Talud {v} Euroopas",
   "titleCountry": "Talud riigis {v}",
   "titleRegion": "Talud piirkonnas {v}",
   "titleCity": "Talud linnas {v}",
   "descType": "Avastage {v} talud ja kasvatajad, kes müüvad otse Ma Petite Ferme kaudu.",
   "descCountry": "Avastage kohalikud talud ja tootjad riigis {v} Ma Petite Ferme kataloogis.",
   "descRegion": "Avastage kohalikud talud ja tootjad piirkonnas {v} Ma Petite Ferme kataloogis.",
   "descCity": "Avastage kohalikud talud ja tootjad linnas {v}, kes müüvad otse Ma Petite Ferme kaudu.",
   "dirStatsTitle": "Minu avalik leht",
   "dirStatsViews": "Profiili vaatamised",
   "dirStatsWeb": "Veebisaidi klõpsud",
   "dirStatsPhone": "Telefoniklõpsud",
   "dirStats30d": "Viimased 30 päeva",
   "pdpBack": "← Tagasi talu juurde",
   "pdpOther": "Teised talu tooted",
   "pdpInStock": "Laos olemas",
   "pdpOut": "Laost otsas",
   "pdpBy": "Müüb",
   "pdpHome": "Avaleht",
   "share": "Jaga",
   "copied": "Link kopeeritud!",
   "favLogin": "Logi sisse",
   "favRegister": "Loo konto",
   "favName": "Nimi",
   "favEmail": "E-post",
   "favPassword": "Parool",
   "favToRegister": "Pole veel kontot? Registreeru",
   "favToLogin": "Juba registreeritud? Logi sisse",
   "favWelcome": "Tere tulemast!",
   "favTitle": "Minu lemmiktalud",
   "favEmpty": "Praegu pole ühtegi lemmiktalu. Sirvi kataloogi ja klõpsa südamel ❤",
   "favLoginPrompt": "Logi sisse, et salvestada ja leida oma lemmiktalud.",
   "favPwdHint": "Vähemalt 6 tähemärki.",
   "fulfillTitle": "Kust oma tooteid teie lähedalt kätte saada",
   "fulfillPickup": "{n} talu(d) pakuvad kohapeal kättesaamist",
   "fulfillDelivery": "{n} talu(d) tarnivad koju",
   "fulfillPoints": "Kättesaamispunktid ja linnad",
   "faqTitle": "Korduma kippuvad küsimused",
   "relatedTitle": "Uuri ka"
  }
 },
 "fi": {
  "sale": {
   "direct": "Suoramyynti",
   "market": "Tori",
   "delivery": "Toimitus",
   "pickup": "Nouto paikan päältä",
   "online": "Verkkokauppa",
   "phone": "Tilaus puhelimitse",
   "email": "Tilaus sähköpostitse"
  },
  "precision": {
   "exact": "Tarkka osoite",
   "approx": "Likimääräinen osoite",
   "city": "Vain kaupunki",
   "region": "Vain alue",
   "hidden": "Piilota sijainti"
  },
  "ui": {
   "title": "Tutustu tiloihin ja kasvattajiin",
   "subtitle": "Tutustu tiloihin ja kasvattajiin, jotka käyttävät Ma Petite Ferme -palvelua toimintansa hallintaan.",
   "searchPh": "Etsi tilaa, kaupunkia, tuotetta…",
   "country": "Maa",
   "animal": "Kasvatustyyppi",
   "sale": "Myyntitapa",
   "all": "Kaikki",
   "mapView": "Näytä kartalla",
   "listView": "Näytä listana",
   "discover": "Tutustu tilaan",
   "verified": "Vahvistettu tila",
   "uses": "Käyttää Ma Petite Ferme -palvelua",
   "noResults": "Tällä haulla ei löytynyt yhtään tilaa.",
   "prev": "Edellinen",
   "next": "Seuraava",
   "results": "tila(t)",
   "ctaTitle": "Oletko kasvattaja?",
   "ctaText": "Luo maksuton julkinen sivu ja liity eurooppalaisten tilojen verkostoon.",
   "ctaBtn": "Hallinnoi tilaani Ma Petite Ferme -palvelulla",
   "secAbout": "Tietoja",
   "secAnimals": "Kasvatuksemme",
   "secSale": "Myynti & jakelu",
   "secGallery": "Galleria",
   "secContact": "Yhteystiedot",
   "secLocation": "Sijainti",
   "report": "Ilmianna tämä sivu",
   "website": "Verkkosivusto",
   "joinTitle": "Liity tilaluetteloon",
   "joinText": "Luo maksuton julkinen sivu ja lisää näkyvyyttäsi kuluttajien keskuudessa.",
   "joinBtn": "Luo julkinen sivuni",
   "navDirectory": "Tilat"
  },
  "cat": {
   "browse": "Selaa luetteloa",
   "byCountry": "Maittain",
   "byRegion": "Alueittain",
   "byType": "Kasvatustyypin mukaan",
   "byCity": "Kaupungeittain",
   "back": "← Takaisin luetteloon",
   "results": "tila(t)",
   "titleType": "Tilat {v} Euroopassa",
   "titleCountry": "Tilat maassa {v}",
   "titleRegion": "Tilat alueella {v}",
   "titleCity": "Tilat kaupungissa {v}",
   "descType": "Tutustu {v}-tiloihin ja kasvattajiin, jotka myyvät suoraan Ma Petite Ferme -palvelussa.",
   "descCountry": "Tutustu paikallisiin tiloihin ja tuottajiin maassa {v} Ma Petite Ferme -luettelossa.",
   "descRegion": "Tutustu paikallisiin tiloihin ja tuottajiin alueella {v} Ma Petite Ferme -luettelossa.",
   "descCity": "Tutustu paikallisiin tiloihin ja tuottajiin kaupungissa {v}, jotka myyvät suoraan Ma Petite Ferme -palvelussa.",
   "dirStatsTitle": "Julkinen sivuni",
   "dirStatsViews": "Profiilin katselukerrat",
   "dirStatsWeb": "Verkkosivuston klikkaukset",
   "dirStatsPhone": "Puhelimen klikkaukset",
   "dirStats30d": "Viimeiset 30 päivää",
   "pdpBack": "← Takaisin tilalle",
   "pdpOther": "Muita tilan tuotteita",
   "pdpInStock": "Varastossa",
   "pdpOut": "Ei varastossa",
   "pdpBy": "Myyjä",
   "pdpHome": "Etusivu",
   "share": "Jaa",
   "copied": "Linkki kopioitu!",
   "favLogin": "Kirjaudu sisään",
   "favRegister": "Luo tili",
   "favName": "Nimi",
   "favEmail": "Sähköposti",
   "favPassword": "Salasana",
   "favToRegister": "Ei vielä tiliä? Rekisteröidy",
   "favToLogin": "Onko sinulla jo tili? Kirjaudu sisään",
   "favWelcome": "Tervetuloa!",
   "favTitle": "Suosikkitilani",
   "favEmpty": "Ei vielä suosikkitiloja. Selaa luetteloa ja napsauta sydäntä ❤",
   "favLoginPrompt": "Kirjaudu sisään tallentaaksesi suosikkitilasi.",
   "favPwdHint": "Vähintään 6 merkkiä.",
   "fulfillTitle": "Mistä noutaa tuotteesi läheltäsi",
   "fulfillPickup": "{n} tila(t) tarjoaa noutoa paikan päältä",
   "fulfillDelivery": "{n} tila(t) toimittaa kotiin",
   "fulfillPoints": "Noutopisteet & kaupungit",
   "faqTitle": "Usein kysytyt kysymykset",
   "relatedTitle": "Tutustu myös"
  }
 },
 "hu": {
  "sale": {
   "direct": "Közvetlen értékesítés",
   "market": "Piac",
   "delivery": "Kiszállítás",
   "pickup": "Helyszíni átvétel",
   "online": "Online bolt",
   "phone": "Telefonos rendelés",
   "email": "E-mailes rendelés"
  },
  "precision": {
   "exact": "Pontos cím",
   "approx": "Hozzávetőleges cím",
   "city": "Csak város",
   "region": "Csak régió",
   "hidden": "Helyszín elrejtése"
  },
  "ui": {
   "title": "Fedezze fel a farmokat és tenyésztőket",
   "subtitle": "Fedezze fel azokat a farmokat és tenyésztőket, akik a Ma Petite Ferme-et használják tevékenységük kezeléséhez.",
   "searchPh": "Farm, város, termék keresése…",
   "country": "Ország",
   "animal": "Tenyésztés típusa",
   "sale": "Értékesítési mód",
   "all": "Összes",
   "mapView": "Megtekintés térképen",
   "listView": "Megtekintés listaként",
   "discover": "Farm felfedezése",
   "verified": "Ellenőrzött farm",
   "uses": "A Ma Petite Ferme-et használja",
   "noResults": "Ehhez a kereséshez nem található farm.",
   "prev": "Előző",
   "next": "Következő",
   "results": "farm(ok)",
   "ctaTitle": "Ön tenyésztő?",
   "ctaText": "Hozza létre ingyenes nyilvános oldalát, és csatlakozzon az európai farmok hálózatához.",
   "ctaBtn": "Farmom kezelése a Ma Petite Ferme-mel",
   "secAbout": "Rólunk",
   "secAnimals": "Tenyésztésünk",
   "secSale": "Értékesítés és elosztás",
   "secGallery": "Galéria",
   "secContact": "Kapcsolat",
   "secLocation": "Helyszín",
   "report": "Az oldal bejelentése",
   "website": "Weboldal",
   "joinTitle": "Csatlakozzon a farmok névjegyzékéhez",
   "joinText": "Hozza létre ingyenes nyilvános oldalát, és növelje láthatóságát a fogyasztók körében.",
   "joinBtn": "Nyilvános oldalam létrehozása",
   "navDirectory": "Farmok"
  },
  "cat": {
   "browse": "Névjegyzék böngészése",
   "byCountry": "Ország szerint",
   "byRegion": "Régió szerint",
   "byType": "Tenyésztés típusa szerint",
   "byCity": "Város szerint",
   "back": "← Vissza a névjegyzékhez",
   "results": "farm(ok)",
   "titleType": "{v} farmok Európában",
   "titleCountry": "Farmok {v}",
   "titleRegion": "Farmok {v}",
   "titleCity": "Farmok {v}",
   "descType": "Fedezze fel azokat a {v} farmokat és tenyésztőket, akik közvetlenül értékesítenek a Ma Petite Ferme-en.",
   "descCountry": "Fedezze fel a helyi farmokat és termelőket {v} a Ma Petite Ferme névjegyzékében.",
   "descRegion": "Fedezze fel a helyi farmokat és termelőket {v} a Ma Petite Ferme névjegyzékében.",
   "descCity": "Fedezze fel a helyi farmokat és termelőket {v} amelyek közvetlenül értékesítenek a Ma Petite Ferme-en.",
   "dirStatsTitle": "Nyilvános oldalam",
   "dirStatsViews": "Profil megtekintések",
   "dirStatsWeb": "Weboldal kattintások",
   "dirStatsPhone": "Telefonos kattintások",
   "dirStats30d": "Elmúlt 30 nap",
   "pdpBack": "← Vissza a farmhoz",
   "pdpOther": "A farm egyéb termékei",
   "pdpInStock": "Készleten",
   "pdpOut": "Elfogyott",
   "pdpBy": "Értékesítő",
   "pdpHome": "Főoldal",
   "share": "Megosztás",
   "copied": "Hivatkozás másolva!",
   "favLogin": "Bejelentkezés",
   "favRegister": "Fiók létrehozása",
   "favName": "Név",
   "favEmail": "E-mail",
   "favPassword": "Jelszó",
   "favToRegister": "Még nincs fiókja? Regisztráljon",
   "favToLogin": "Már regisztrált? Bejelentkezés",
   "favWelcome": "Üdvözöljük!",
   "favTitle": "Kedvenc farmjaim",
   "favEmpty": "Egyelőre nincs kedvenc farm. Böngésszen a névjegyzékben, és kattintson a szívre ❤",
   "favLoginPrompt": "Jelentkezzen be, hogy elmenthesse és megtalálhassa kedvenc farmjait.",
   "favPwdHint": "Legalább 6 karakter.",
   "fulfillTitle": "Hol veheti át termékeit az Ön közelében",
   "fulfillPickup": "{n} farm kínál helyszíni átvételt",
   "fulfillDelivery": "{n} farm szállít házhoz",
   "fulfillPoints": "Átvételi pontok és városok",
   "faqTitle": "Gyakran ismételt kérdések",
   "relatedTitle": "Fedezze fel ezeket is"
  }
 },
 "pl": {
  "sale": {
   "direct": "Sprzedaż bezpośrednia",
   "market": "Targ",
   "delivery": "Dostawa",
   "pickup": "Odbiór osobisty",
   "online": "Sklep internetowy",
   "phone": "Zamówienie telefoniczne",
   "email": "Zamówienie e-mailem"
  },
  "precision": {
   "exact": "Dokładny adres",
   "approx": "Przybliżony adres",
   "city": "Tylko miasto",
   "region": "Tylko region",
   "hidden": "Ukryj lokalizację"
  },
  "ui": {
   "title": "Odkryj gospodarstwa i hodowców",
   "subtitle": "Odkryj gospodarstwa i hodowców, którzy używają Ma Petite Ferme do zarządzania swoją działalnością.",
   "searchPh": "Szukaj gospodarstwa, miasta, produktu…",
   "country": "Kraj",
   "animal": "Rodzaj hodowli",
   "sale": "Sposób sprzedaży",
   "all": "Wszystkie",
   "mapView": "Zobacz na mapie",
   "listView": "Zobacz jako lista",
   "discover": "Odkryj gospodarstwo",
   "verified": "Zweryfikowane gospodarstwo",
   "uses": "Używa Ma Petite Ferme",
   "noResults": "Nie znaleziono żadnego gospodarstwa dla tego wyszukiwania.",
   "prev": "Poprzedni",
   "next": "Następny",
   "results": "gospodarstwo(a)",
   "ctaTitle": "Jesteś hodowcą?",
   "ctaText": "Utwórz swoją bezpłatną stronę publiczną i dołącz do sieci europejskich gospodarstw.",
   "ctaBtn": "Zarządzaj moim gospodarstwem z Ma Petite Ferme",
   "secAbout": "O nas",
   "secAnimals": "Nasza hodowla",
   "secSale": "Sprzedaż i dystrybucja",
   "secGallery": "Galeria",
   "secContact": "Kontakt",
   "secLocation": "Lokalizacja",
   "report": "Zgłoś tę stronę",
   "website": "Strona internetowa",
   "joinTitle": "Dołącz do katalogu gospodarstw",
   "joinText": "Utwórz swoją bezpłatną stronę publiczną i zyskaj widoczność wśród konsumentów.",
   "joinBtn": "Utwórz moją stronę publiczną",
   "navDirectory": "Gospodarstwa"
  },
  "cat": {
   "browse": "Przeglądaj katalog",
   "byCountry": "Według kraju",
   "byRegion": "Według regionu",
   "byType": "Według rodzaju hodowli",
   "byCity": "Według miasta",
   "back": "← Powrót do katalogu",
   "results": "gospodarstwo(a)",
   "titleType": "Gospodarstwa {v} w Europie",
   "titleCountry": "Gospodarstwa w {v}",
   "titleRegion": "Gospodarstwa w {v}",
   "titleCity": "Gospodarstwa w {v}",
   "descType": "Odkryj gospodarstwa i hodowców {v}, którzy sprzedają bezpośrednio na Ma Petite Ferme.",
   "descCountry": "Odkryj lokalne gospodarstwa i producentów w {v} w katalogu Ma Petite Ferme.",
   "descRegion": "Odkryj lokalne gospodarstwa i producentów w {v} w katalogu Ma Petite Ferme.",
   "descCity": "Odkryj lokalne gospodarstwa i producentów w {v}, którzy sprzedają bezpośrednio na Ma Petite Ferme.",
   "dirStatsTitle": "Moja strona publiczna",
   "dirStatsViews": "Wyświetlenia profilu",
   "dirStatsWeb": "Kliknięcia strony internetowej",
   "dirStatsPhone": "Kliknięcia telefonu",
   "dirStats30d": "Ostatnie 30 dni",
   "pdpBack": "← Powrót do gospodarstwa",
   "pdpOther": "Inne produkty z gospodarstwa",
   "pdpInStock": "W magazynie",
   "pdpOut": "Brak w magazynie",
   "pdpBy": "Sprzedawane przez",
   "pdpHome": "Strona główna",
   "share": "Udostępnij",
   "copied": "Link skopiowany!",
   "favLogin": "Zaloguj się",
   "favRegister": "Utwórz konto",
   "favName": "Imię",
   "favEmail": "E-mail",
   "favPassword": "Hasło",
   "favToRegister": "Nie masz jeszcze konta? Zarejestruj się",
   "favToLogin": "Masz już konto? Zaloguj się",
   "favWelcome": "Witamy!",
   "favTitle": "Moje ulubione gospodarstwa",
   "favEmpty": "Brak ulubionych gospodarstw. Przeglądaj katalog i klikaj serce ❤",
   "favLoginPrompt": "Zaloguj się, aby zapisywać i odnajdywać swoje ulubione gospodarstwa.",
   "favPwdHint": "Minimum 6 znaków.",
   "fulfillTitle": "Gdzie odebrać swoje produkty w pobliżu",
   "fulfillPickup": "{n} gospodarstwo(a) oferuje odbiór osobisty",
   "fulfillDelivery": "{n} gospodarstwo(a) dostarcza do domu",
   "fulfillPoints": "Punkty odbioru i miasta",
   "faqTitle": "Często zadawane pytania",
   "relatedTitle": "Odkryj także"
  }
 },
 "lv": {
  "sale": {
   "direct": "Tieša pārdošana",
   "market": "Tirgus",
   "delivery": "Piegāde",
   "pickup": "Saņemšana uz vietas",
   "online": "Interneta veikals",
   "phone": "Pasūtījums pa tālruni",
   "email": "Pasūtījums pa e-pastu"
  },
  "precision": {
   "exact": "Precīza adrese",
   "approx": "Aptuvena adrese",
   "city": "Tikai pilsēta",
   "region": "Tikai reģions",
   "hidden": "Slēpt atrašanās vietu"
  },
  "ui": {
   "title": "Atklājiet saimniecības un lopkopjus",
   "subtitle": "Atklājiet saimniecības un lopkopjus, kas izmanto Ma Petite Ferme savas darbības pārvaldībai.",
   "searchPh": "Meklēt saimniecību, pilsētu, produktu…",
   "country": "Valsts",
   "animal": "Lopkopības veids",
   "sale": "Pārdošanas veids",
   "all": "Visi",
   "mapView": "Skatīt kartē",
   "listView": "Skatīt sarakstā",
   "discover": "Uzzināt par saimniecību",
   "verified": "Verificēta saimniecība",
   "uses": "Izmanto Ma Petite Ferme",
   "noResults": "Šim meklējumam nav atrasta neviena saimniecība.",
   "prev": "Iepriekšējais",
   "next": "Nākamais",
   "results": "saimniecība(s)",
   "ctaTitle": "Vai esat lopkopis?",
   "ctaText": "Izveidojiet savu bezmaksas publisko lapu un pievienojieties Eiropas saimniecību tīklam.",
   "ctaBtn": "Pārvaldīt manu saimniecību ar Ma Petite Ferme",
   "secAbout": "Par mums",
   "secAnimals": "Mūsu lopkopība",
   "secSale": "Pārdošana un izplatīšana",
   "secGallery": "Galerija",
   "secContact": "Kontakti",
   "secLocation": "Atrašanās vieta",
   "report": "Ziņot par šo lapu",
   "website": "Tīmekļa vietne",
   "joinTitle": "Pievienojieties saimniecību katalogam",
   "joinText": "Izveidojiet savu bezmaksas publisko lapu un iegūstiet lielāku redzamību patērētāju vidū.",
   "joinBtn": "Izveidot manu publisko lapu",
   "navDirectory": "Saimniecības"
  },
  "cat": {
   "browse": "Pārlūkot katalogu",
   "byCountry": "Pēc valsts",
   "byRegion": "Pēc reģiona",
   "byType": "Pēc lopkopības veida",
   "byCity": "Pēc pilsētas",
   "back": "← Atpakaļ uz katalogu",
   "results": "saimniecība(s)",
   "titleType": "Saimniecības {v} Eiropā",
   "titleCountry": "Saimniecības {v}",
   "titleRegion": "Saimniecības {v}",
   "titleCity": "Saimniecības {v}",
   "descType": "Atklājiet {v} saimniecības un lopkopjus, kas pārdod tieši vietnē Ma Petite Ferme.",
   "descCountry": "Atklājiet vietējās saimniecības un ražotājus {v} vietnes Ma Petite Ferme katalogā.",
   "descRegion": "Atklājiet vietējās saimniecības un ražotājus {v} vietnes Ma Petite Ferme katalogā.",
   "descCity": "Atklājiet vietējās saimniecības un ražotājus {v}, kas pārdod tieši vietnē Ma Petite Ferme.",
   "dirStatsTitle": "Mana publiskā lapa",
   "dirStatsViews": "Profila skatījumi",
   "dirStatsWeb": "Klikšķi uz vietnes",
   "dirStatsPhone": "Klikšķi uz tālruņa",
   "dirStats30d": "Pēdējās 30 dienas",
   "pdpBack": "← Atpakaļ uz saimniecību",
   "pdpOther": "Citi saimniecības produkti",
   "pdpInStock": "Noliktavā",
   "pdpOut": "Nav noliktavā",
   "pdpBy": "Pārdod",
   "pdpHome": "Sākums",
   "share": "Kopīgot",
   "copied": "Saite nokopēta!",
   "favLogin": "Pieteikties",
   "favRegister": "Izveidot kontu",
   "favName": "Vārds",
   "favEmail": "E-pasts",
   "favPassword": "Parole",
   "favToRegister": "Vēl nav konta? Reģistrēties",
   "favToLogin": "Jau reģistrējies? Pieteikties",
   "favWelcome": "Laipni lūdzam!",
   "favTitle": "Manas iecienītākās saimniecības",
   "favEmpty": "Pagaidām nav nevienas iecienītās saimniecības. Pārlūkojiet katalogu un noklikšķiniet uz sirds ❤",
   "favLoginPrompt": "Piesakieties, lai saglabātu un atrastu savas iecienītākās saimniecības.",
   "favPwdHint": "Vismaz 6 rakstzīmes.",
   "fulfillTitle": "Kur saņemt savus produktus netālu no jums",
   "fulfillPickup": "{n} saimniecība(s) piedāvā saņemšanu uz vietas",
   "fulfillDelivery": "{n} saimniecība(s) piegādā mājās",
   "fulfillPoints": "Saņemšanas punkti un pilsētas",
   "faqTitle": "Biežāk uzdotie jautājumi",
   "relatedTitle": "Izpētiet arī"
  }
 },
 "pt": {
  "sale": {
   "direct": "Venda direta",
   "market": "Mercado",
   "delivery": "Entrega",
   "pickup": "Retirada no local",
   "online": "Loja online",
   "phone": "Pedido por telefone",
   "email": "Pedido por e-mail"
  },
  "precision": {
   "exact": "Endereço exato",
   "approx": "Endereço aproximado",
   "city": "Apenas cidade",
   "region": "Apenas região",
   "hidden": "Ocultar localização"
  },
  "ui": {
   "title": "Descubra as fazendas e criadores",
   "subtitle": "Descubra as fazendas e criadores que utilizam Ma Petite Ferme para gerir a sua atividade.",
   "searchPh": "Pesquisar uma fazenda, uma cidade, um produto…",
   "country": "País",
   "animal": "Tipo de criação",
   "sale": "Modo de venda",
   "all": "Todos",
   "mapView": "Ver no mapa",
   "listView": "Ver em lista",
   "discover": "Descobrir a fazenda",
   "verified": "Fazenda verificada",
   "uses": "Utiliza Ma Petite Ferme",
   "noResults": "Nenhuma fazenda encontrada para esta pesquisa.",
   "prev": "Anterior",
   "next": "Seguinte",
   "results": "fazenda(s)",
   "ctaTitle": "É criador?",
   "ctaText": "Crie a sua página pública gratuita e junte-se à rede de fazendas europeias.",
   "ctaBtn": "Gerir a minha fazenda com Ma Petite Ferme",
   "secAbout": "Sobre",
   "secAnimals": "A nossa criação",
   "secSale": "Venda & distribuição",
   "secGallery": "Galeria",
   "secContact": "Contacto",
   "secLocation": "Localização",
   "report": "Denunciar esta página",
   "website": "Site internet",
   "joinTitle": "Junte-se ao diretório de fazendas",
   "joinText": "Crie a sua página pública gratuita e ganhe visibilidade junto dos consumidores.",
   "joinBtn": "Criar a minha página pública",
   "navDirectory": "Fazendas"
  },
  "cat": {
   "browse": "Explorar o diretório",
   "byCountry": "Por país",
   "byRegion": "Por região",
   "byType": "Por tipo de criação",
   "byCity": "Por cidade",
   "back": "← Voltar ao diretório",
   "results": "fazenda(s)",
   "titleType": "Fazendas {v} na Europa",
   "titleCountry": "Fazendas em {v}",
   "titleRegion": "Fazendas em {v}",
   "titleCity": "Fazendas em {v}",
   "descType": "Descubra as fazendas e criadores {v} que vendem diretamente na Ma Petite Ferme.",
   "descCountry": "Descubra as fazendas e produtores locais em {v} no diretório Ma Petite Ferme.",
   "descRegion": "Descubra as fazendas e produtores locais em {v} no diretório Ma Petite Ferme.",
   "descCity": "Descubra as fazendas e produtores locais em {v} que vendem diretamente na Ma Petite Ferme.",
   "dirStatsTitle": "A minha página pública",
   "dirStatsViews": "Visualizações do perfil",
   "dirStatsWeb": "Cliques no site",
   "dirStatsPhone": "Cliques no telefone",
   "dirStats30d": "Últimos 30 dias",
   "pdpBack": "← Voltar à fazenda",
   "pdpOther": "Outros produtos da fazenda",
   "pdpInStock": "Em stock",
   "pdpOut": "Esgotado",
   "pdpBy": "Vendido por",
   "pdpHome": "Início",
   "share": "Partilhar",
   "copied": "Link copiado!",
   "favLogin": "Iniciar sessão",
   "favRegister": "Criar uma conta",
   "favName": "Nome",
   "favEmail": "E-mail",
   "favPassword": "Palavra-passe",
   "favToRegister": "Ainda não tem conta? Registar-se",
   "favToLogin": "Já está registado? Iniciar sessão",
   "favWelcome": "Bem-vindo(a)!",
   "favTitle": "As minhas fazendas favoritas",
   "favEmpty": "Nenhuma fazenda nos favoritos por enquanto. Explore o diretório e clique no coração ❤",
   "favLoginPrompt": "Inicie sessão para guardar e encontrar as suas fazendas favoritas.",
   "favPwdHint": "Mínimo de 6 caracteres.",
   "fulfillTitle": "Onde recolher os seus produtos perto de si",
   "fulfillPickup": "{n} fazenda(s) oferecem retirada no local",
   "fulfillDelivery": "{n} fazenda(s) entregam ao domicílio",
   "fulfillPoints": "Pontos de retirada & cidades",
   "faqTitle": "Perguntas frequentes",
   "relatedTitle": "Explore também"
  }
 },
 "lt": {
  "sale": {
   "direct": "Tiesioginis pardavimas",
   "market": "Turgus",
   "delivery": "Pristatymas",
   "pickup": "Atsiėmimas vietoje",
   "online": "Internetinė parduotuvė",
   "phone": "Užsakymas telefonu",
   "email": "Užsakymas el. paštu"
  },
  "precision": {
   "exact": "Tikslus adresas",
   "approx": "Apytikslis adresas",
   "city": "Tik miestas",
   "region": "Tik regionas",
   "hidden": "Slėpti vietovę"
  },
  "ui": {
   "title": "Atraskite ūkius ir augintojus",
   "subtitle": "Atraskite ūkius ir augintojus, kurie naudoja Ma Petite Ferme savo veiklai valdyti.",
   "searchPh": "Ieškoti ūkio, miesto, produkto…",
   "country": "Šalis",
   "animal": "Gyvulininkystės tipas",
   "sale": "Pardavimo būdas",
   "all": "Visi",
   "mapView": "Žiūrėti žemėlapyje",
   "listView": "Žiūrėti sąraše",
   "discover": "Atrasti ūkį",
   "verified": "Patvirtintas ūkis",
   "uses": "Naudoja Ma Petite Ferme",
   "noResults": "Nerasta jokio ūkio pagal šią paiešką.",
   "prev": "Ankstesnis",
   "next": "Kitas",
   "results": "ūkis (-iai)",
   "ctaTitle": "Esate gyvulių augintojas?",
   "ctaText": "Sukurkite nemokamą viešą puslapį ir prisijunkite prie Europos ūkių tinklo.",
   "ctaBtn": "Valdyti savo ūkį su Ma Petite Ferme",
   "secAbout": "Apie mus",
   "secAnimals": "Mūsų gyvulininkystė",
   "secSale": "Pardavimas ir paskirstymas",
   "secGallery": "Galerija",
   "secContact": "Kontaktai",
   "secLocation": "Vieta",
   "report": "Pranešti apie šį puslapį",
   "website": "Interneto svetainė",
   "joinTitle": "Prisijunkite prie ūkių katalogo",
   "joinText": "Sukurkite nemokamą viešą puslapį ir padidinkite savo matomumą vartotojams.",
   "joinBtn": "Sukurti viešą puslapį",
   "navDirectory": "Ūkiai"
  },
  "cat": {
   "browse": "Naršyti katalogą",
   "byCountry": "Pagal šalį",
   "byRegion": "Pagal regioną",
   "byType": "Pagal gyvulininkystės tipą",
   "byCity": "Pagal miestą",
   "back": "← Grįžti į katalogą",
   "results": "ūkis (-iai)",
   "titleType": "Ūkiai {v} Europoje",
   "titleCountry": "Ūkiai {v}",
   "titleRegion": "Ūkiai {v}",
   "titleCity": "Ūkiai {v}",
   "descType": "Atraskite {v} ūkius ir augintojus, kurie parduoda tiesiogiai per Ma Petite Ferme.",
   "descCountry": "Atraskite vietos ūkius ir gamintojus {v} Ma Petite Ferme kataloge.",
   "descRegion": "Atraskite vietos ūkius ir gamintojus {v} Ma Petite Ferme kataloge.",
   "descCity": "Atraskite vietos ūkius ir gamintojus {v}, kurie parduoda tiesiogiai per Ma Petite Ferme.",
   "dirStatsTitle": "Mano viešas puslapis",
   "dirStatsViews": "Profilio peržiūros",
   "dirStatsWeb": "Svetainės paspaudimai",
   "dirStatsPhone": "Telefono paspaudimai",
   "dirStats30d": "Paskutinės 30 dienų",
   "pdpBack": "← Grįžti į ūkį",
   "pdpOther": "Kiti ūkio produktai",
   "pdpInStock": "Yra sandėlyje",
   "pdpOut": "Išparduota",
   "pdpBy": "Parduoda",
   "pdpHome": "Pradžia",
   "share": "Dalintis",
   "copied": "Nuoroda nukopijuota!",
   "favLogin": "Prisijungti",
   "favRegister": "Sukurti paskyrą",
   "favName": "Vardas",
   "favEmail": "El. paštas",
   "favPassword": "Slaptažodis",
   "favToRegister": "Dar neturite paskyros? Registruotis",
   "favToLogin": "Jau užsiregistravęs? Prisijungti",
   "favWelcome": "Sveiki!",
   "favTitle": "Mano mėgstami ūkiai",
   "favEmpty": "Kol kas nėra mėgstamų ūkių. Naršykite katalogą ir spustelėkite širdį ❤",
   "favLoginPrompt": "Prisijunkite, kad išsaugotumėte ir rastumėte savo mėgstamus ūkius.",
   "favPwdHint": "Mažiausiai 6 simboliai.",
   "fulfillTitle": "Kur atsiimti produktus netoli jūsų",
   "fulfillPickup": "{n} ūkis (-iai) siūlo atsiėmimą vietoje",
   "fulfillDelivery": "{n} ūkis (-iai) pristato į namus",
   "fulfillPoints": "Atsiėmimo punktai ir miestai",
   "faqTitle": "Dažniausiai užduodami klausimai",
   "relatedTitle": "Taip pat naršykite"
  }
 },
 "ro": {
  "sale": {
   "direct": "Vânzare directă",
   "market": "Piață",
   "delivery": "Livrare",
   "pickup": "Ridicare la fața locului",
   "online": "Magazin online",
   "phone": "Comandă prin telefon",
   "email": "Comandă prin email"
  },
  "precision": {
   "exact": "Adresă exactă",
   "approx": "Adresă aproximativă",
   "city": "Doar orașul",
   "region": "Doar regiunea",
   "hidden": "Ascunde localizarea"
  },
  "ui": {
   "title": "Descoperiți fermele și crescătorii",
   "subtitle": "Descoperiți fermele și crescătorii care folosesc Ma Petite Ferme pentru a-și gestiona activitatea.",
   "searchPh": "Căutați o fermă, un oraș, un produs…",
   "country": "Țară",
   "animal": "Tip de creștere",
   "sale": "Mod de vânzare",
   "all": "Toate",
   "mapView": "Vezi pe hartă",
   "listView": "Vezi ca listă",
   "discover": "Descoperă ferma",
   "verified": "Fermă verificată",
   "uses": "Folosește Ma Petite Ferme",
   "noResults": "Nicio fermă găsită pentru această căutare.",
   "prev": "Anterior",
   "next": "Următor",
   "results": "fermă(e)",
   "ctaTitle": "Sunteți crescător?",
   "ctaText": "Creați-vă pagina publică gratuită și alăturați-vă rețelei fermelor europene.",
   "ctaBtn": "Administrează-mi ferma cu Ma Petite Ferme",
   "secAbout": "Despre noi",
   "secAnimals": "Creșterea noastră",
   "secSale": "Vânzare & distribuție",
   "secGallery": "Galerie",
   "secContact": "Contact",
   "secLocation": "Localizare",
   "report": "Raportați această pagină",
   "website": "Site web",
   "joinTitle": "Alăturați-vă directorului de ferme",
   "joinText": "Creați-vă pagina publică gratuită și câștigați vizibilitate în rândul consumatorilor.",
   "joinBtn": "Creează-mi pagina publică",
   "navDirectory": "Ferme"
  },
  "cat": {
   "browse": "Răsfoiți directorul",
   "byCountry": "Pe țară",
   "byRegion": "Pe regiune",
   "byType": "Pe tip de creștere",
   "byCity": "Pe oraș",
   "back": "← Înapoi la director",
   "results": "fermă(e)",
   "titleType": "Ferme {v} în Europa",
   "titleCountry": "Ferme în {v}",
   "titleRegion": "Ferme în {v}",
   "titleCity": "Ferme în {v}",
   "descType": "Descoperiți fermele și crescătorii {v} care vând direct pe Ma Petite Ferme.",
   "descCountry": "Descoperiți fermele și producătorii locali din {v} pe directorul Ma Petite Ferme.",
   "descRegion": "Descoperiți fermele și producătorii locali din {v} pe directorul Ma Petite Ferme.",
   "descCity": "Descoperiți fermele și producătorii locali din {v} care vând direct pe Ma Petite Ferme.",
   "dirStatsTitle": "Pagina mea publică",
   "dirStatsViews": "Vizualizări profil",
   "dirStatsWeb": "Clicuri site web",
   "dirStatsPhone": "Clicuri telefon",
   "dirStats30d": "Ultimele 30 de zile",
   "pdpBack": "← Înapoi la fermă",
   "pdpOther": "Alte produse ale fermei",
   "pdpInStock": "În stoc",
   "pdpOut": "Stoc epuizat",
   "pdpBy": "Vândut de",
   "pdpHome": "Acasă",
   "share": "Distribuie",
   "copied": "Link copiat!",
   "favLogin": "Conectare",
   "favRegister": "Creează un cont",
   "favName": "Nume",
   "favEmail": "E-mail",
   "favPassword": "Parolă",
   "favToRegister": "Nu ai cont încă? Înregistrează-te",
   "favToLogin": "Ai deja cont? Conectează-te",
   "favWelcome": "Bun venit!",
   "favTitle": "Fermele mele favorite",
   "favEmpty": "Nicio fermă la favorite deocamdată. Explorați directorul și faceți clic pe inimă ❤",
   "favLoginPrompt": "Conectați-vă pentru a salva și regăsi fermele voastre favorite.",
   "favPwdHint": "Minimum 6 caractere.",
   "fulfillTitle": "Unde să vă ridicați produsele din apropierea dvs.",
   "fulfillPickup": "{n} fermă(e) oferă ridicare la fața locului",
   "fulfillDelivery": "{n} fermă(e) livrează la domiciliu",
   "fulfillPoints": "Puncte de ridicare & orașe",
   "faqTitle": "Întrebări frecvente",
   "relatedTitle": "Explorați și"
  }
 },
 "sk": {
  "sale": {
   "direct": "Priamy predaj",
   "market": "Trh",
   "delivery": "Doručenie",
   "pickup": "Vyzdvihnutie na mieste",
   "online": "Online obchod",
   "phone": "Objednávka telefonicky",
   "email": "Objednávka emailom"
  },
  "precision": {
   "exact": "Presná adresa",
   "approx": "Približná adresa",
   "city": "Iba mesto",
   "region": "Iba región",
   "hidden": "Skryť polohu"
  },
  "ui": {
   "title": "Objavte farmy a chovateľov",
   "subtitle": "Objavte farmy a chovateľov, ktorí používajú Ma Petite Ferme na správu svojej činnosti.",
   "searchPh": "Hľadať farmu, mesto, produkt…",
   "country": "Krajina",
   "animal": "Typ chovu",
   "sale": "Spôsob predaja",
   "all": "Všetky",
   "mapView": "Zobraziť na mape",
   "listView": "Zobraziť ako zoznam",
   "discover": "Objaviť farmu",
   "verified": "Overená farma",
   "uses": "Používa Ma Petite Ferme",
   "noResults": "Pre toto vyhľadávanie sa nenašla žiadna farma.",
   "prev": "Predchádzajúci",
   "next": "Nasledujúci",
   "results": "farma(y)",
   "ctaTitle": "Ste chovateľ?",
   "ctaText": "Vytvorte si bezplatnú verejnú stránku a pridajte sa k sieti európskych fariem.",
   "ctaBtn": "Spravovať moju farmu s Ma Petite Ferme",
   "secAbout": "O nás",
   "secAnimals": "Náš chov",
   "secSale": "Predaj a distribúcia",
   "secGallery": "Galéria",
   "secContact": "Kontakt",
   "secLocation": "Poloha",
   "report": "Nahlásiť túto stránku",
   "website": "Webová stránka",
   "joinTitle": "Pridajte sa do adresára fariem",
   "joinText": "Vytvorte si bezplatnú verejnú stránku a zvýšte svoju viditeľnosť medzi spotrebiteľmi.",
   "joinBtn": "Vytvoriť moju verejnú stránku",
   "navDirectory": "Farmy"
  },
  "cat": {
   "browse": "Prechádzať adresár",
   "byCountry": "Podľa krajiny",
   "byRegion": "Podľa regiónu",
   "byType": "Podľa typu chovu",
   "byCity": "Podľa mesta",
   "back": "← Späť do adresára",
   "results": "farma(y)",
   "titleType": "Farmy {v} v Európe",
   "titleCountry": "Farmy v {v}",
   "titleRegion": "Farmy v {v}",
   "titleCity": "Farmy v {v}",
   "descType": "Objavte farmy a chovateľov {v}, ktorí predávajú priamo na Ma Petite Ferme.",
   "descCountry": "Objavte miestne farmy a výrobcov v {v} v adresári Ma Petite Ferme.",
   "descRegion": "Objavte miestne farmy a výrobcov v {v} v adresári Ma Petite Ferme.",
   "descCity": "Objavte miestne farmy a výrobcov v {v}, ktorí predávajú priamo na Ma Petite Ferme.",
   "dirStatsTitle": "Moja verejná stránka",
   "dirStatsViews": "Zobrazenia profilu",
   "dirStatsWeb": "Kliknutia na webovú stránku",
   "dirStatsPhone": "Kliknutia na telefón",
   "dirStats30d": "Posledných 30 dní",
   "pdpBack": "← Späť na farmu",
   "pdpOther": "Ďalšie produkty z farmy",
   "pdpInStock": "Skladom",
   "pdpOut": "Vypredané",
   "pdpBy": "Predáva",
   "pdpHome": "Domov",
   "share": "Zdieľať",
   "copied": "Odkaz skopírovaný!",
   "favLogin": "Prihlásiť sa",
   "favRegister": "Vytvoriť účet",
   "favName": "Meno",
   "favEmail": "E-mail",
   "favPassword": "Heslo",
   "favToRegister": "Nemáte účet? Zaregistrujte sa",
   "favToLogin": "Už máte účet? Prihláste sa",
   "favWelcome": "Vitajte!",
   "favTitle": "Moje obľúbené farmy",
   "favEmpty": "Zatiaľ žiadne obľúbené farmy. Prezrite adresár a kliknite na srdce ❤",
   "favLoginPrompt": "Prihláste sa, aby ste mohli uložiť a nájsť svoje obľúbené farmy.",
   "favPwdHint": "Minimálne 6 znakov.",
   "fulfillTitle": "Kde vyzdvihnúť vaše produkty vo vašej blízkosti",
   "fulfillPickup": "{n} farma(y) ponúkajú vyzdvihnutie na mieste",
   "fulfillDelivery": "{n} farma(y) doručujú domov",
   "fulfillPoints": "Miesta vyzdvihnutia a mestá",
   "faqTitle": "Časté otázky",
   "relatedTitle": "Preskúmajte aj"
  }
 },
 "sl": {
  "sale": {
   "direct": "Neposredna prodaja",
   "market": "Tržnica",
   "delivery": "Dostava",
   "pickup": "Prevzem na kraju samem",
   "online": "Spletna trgovina",
   "phone": "Naročilo po telefonu",
   "email": "Naročilo po e-pošti"
  },
  "precision": {
   "exact": "Točen naslov",
   "approx": "Približen naslov",
   "city": "Samo mesto",
   "region": "Samo regija",
   "hidden": "Skrij lokacijo"
  },
  "ui": {
   "title": "Odkrijte kmetije in rejce",
   "subtitle": "Odkrijte kmetije in rejce, ki uporabljajo Ma Petite Ferme za upravljanje svoje dejavnosti.",
   "searchPh": "Poiščite kmetijo, mesto, izdelek …",
   "country": "Država",
   "animal": "Vrsta reje",
   "sale": "Način prodaje",
   "all": "Vse",
   "mapView": "Poglej na zemljevidu",
   "listView": "Poglej kot seznam",
   "discover": "Odkrijte kmetijo",
   "verified": "Preverjena kmetija",
   "uses": "Uporablja Ma Petite Ferme",
   "noResults": "Za to iskanje ni bila najdena nobena kmetija.",
   "prev": "Prejšnji",
   "next": "Naslednji",
   "results": "kmetija(e)",
   "ctaTitle": "Ste rejec?",
   "ctaText": "Ustvarite svojo brezplačno javno stran in se pridružite mreži evropskih kmetij.",
   "ctaBtn": "Upravljajte svojo kmetijo z Ma Petite Ferme",
   "secAbout": "O nas",
   "secAnimals": "Naša reja",
   "secSale": "Prodaja in distribucija",
   "secGallery": "Galerija",
   "secContact": "Kontakt",
   "secLocation": "Lokacija",
   "report": "Prijavi to stran",
   "website": "Spletna stran",
   "joinTitle": "Pridružite se imeniku kmetij",
   "joinText": "Ustvarite svojo brezplačno javno stran in pridobite vidnost pri potrošnikih.",
   "joinBtn": "Ustvari mojo javno stran",
   "navDirectory": "Kmetije"
  },
  "cat": {
   "browse": "Brskaj po imeniku",
   "byCountry": "Po državah",
   "byRegion": "Po regijah",
   "byType": "Po vrsti reje",
   "byCity": "Po mestih",
   "back": "← Nazaj na imenik",
   "results": "kmetija(e)",
   "titleType": "Kmetije {v} v Evropi",
   "titleCountry": "Kmetije v {v}",
   "titleRegion": "Kmetije v {v}",
   "titleCity": "Kmetije v {v}",
   "descType": "Odkrijte kmetije in rejce {v}, ki prodajajo neposredno prek Ma Petite Ferme.",
   "descCountry": "Odkrijte kmetije in lokalne pridelovalce v {v} v imeniku Ma Petite Ferme.",
   "descRegion": "Odkrijte kmetije in lokalne pridelovalce v {v} v imeniku Ma Petite Ferme.",
   "descCity": "Odkrijte kmetije in lokalne pridelovalce v {v}, ki prodajajo neposredno prek Ma Petite Ferme.",
   "dirStatsTitle": "Moja javna stran",
   "dirStatsViews": "Ogledi profila",
   "dirStatsWeb": "Kliki na spletno stran",
   "dirStatsPhone": "Kliki na telefon",
   "dirStats30d": "Zadnjih 30 dni",
   "pdpBack": "← Nazaj na kmetijo",
   "pdpOther": "Drugi izdelki kmetije",
   "pdpInStock": "Na zalogi",
   "pdpOut": "Ni na zalogi",
   "pdpBy": "Prodaja",
   "pdpHome": "Domov",
   "share": "Deli",
   "copied": "Povezava kopirana!",
   "favLogin": "Prijava",
   "favRegister": "Ustvari račun",
   "favName": "Ime",
   "favEmail": "E-pošta",
   "favPassword": "Geslo",
   "favToRegister": "Še nimate računa? Registracija",
   "favToLogin": "Že imate račun? Prijava",
   "favWelcome": "Dobrodošli!",
   "favTitle": "Moje priljubljene kmetije",
   "favEmpty": "Zaenkrat ni priljubljenih kmetij. Raziščite imenik in kliknite na srce ❤",
   "favLoginPrompt": "Prijavite se, da shranite in poiščete svoje priljubljene kmetije.",
   "favPwdHint": "Najmanj 6 znakov.",
   "fulfillTitle": "Kje prevzeti vaše izdelke v bližini",
   "fulfillPickup": "{n} kmetija(e) ponuja prevzem na kraju samem",
   "fulfillDelivery": "{n} kmetija(e) dostavlja na dom",
   "fulfillPoints": "Prevzemna mesta in mesta",
   "faqTitle": "Pogosta vprašanja",
   "relatedTitle": "Raziščite tudi"
  }
 },
 "cs": {
  "sale": {
   "direct": "Přímý prodej",
   "market": "Trh",
   "delivery": "Doručení",
   "pickup": "Vyzvednutí na místě",
   "online": "Online obchod",
   "phone": "Objednávka telefonem",
   "email": "Objednávka e-mailem"
  },
  "precision": {
   "exact": "Přesná adresa",
   "approx": "Přibližná adresa",
   "city": "Pouze město",
   "region": "Pouze region",
   "hidden": "Skrýt polohu"
  },
  "ui": {
   "title": "Objevte farmy a chovatele",
   "subtitle": "Objevte farmy a chovatele, kteří používají Ma Petite Ferme ke správě své činnosti.",
   "searchPh": "Hledat farmu, město, produkt…",
   "country": "Země",
   "animal": "Typ chovu",
   "sale": "Způsob prodeje",
   "all": "Vše",
   "mapView": "Zobrazit na mapě",
   "listView": "Zobrazit jako seznam",
   "discover": "Objevit farmu",
   "verified": "Ověřená farma",
   "uses": "Používá Ma Petite Ferme",
   "noResults": "Pro toto hledání nebyla nalezena žádná farma.",
   "prev": "Předchozí",
   "next": "Další",
   "results": "farma/farmy",
   "ctaTitle": "Jste chovatel?",
   "ctaText": "Vytvořte si svou bezplatnou veřejnou stránku a připojte se k síti evropských farem.",
   "ctaBtn": "Spravovat moji farmu s Ma Petite Ferme",
   "secAbout": "O nás",
   "secAnimals": "Náš chov",
   "secSale": "Prodej a distribuce",
   "secGallery": "Galerie",
   "secContact": "Kontakt",
   "secLocation": "Poloha",
   "report": "Nahlásit tuto stránku",
   "website": "Webové stránky",
   "joinTitle": "Připojte se do adresáře farem",
   "joinText": "Vytvořte si bezplatnou veřejnou stránku a získejte větší viditelnost u spotřebitelů.",
   "joinBtn": "Vytvořit moji veřejnou stránku",
   "navDirectory": "Farmy"
  },
  "cat": {
   "browse": "Procházet adresář",
   "byCountry": "Podle země",
   "byRegion": "Podle regionu",
   "byType": "Podle typu chovu",
   "byCity": "Podle města",
   "back": "← Zpět do adresáře",
   "results": "farma/farmy",
   "titleType": "Farmy {v} v Evropě",
   "titleCountry": "Farmy v {v}",
   "titleRegion": "Farmy v {v}",
   "titleCity": "Farmy v {v}",
   "descType": "Objevte farmy a chovatele {v}, kteří prodávají přímo na Ma Petite Ferme.",
   "descCountry": "Objevte místní farmy a producenty v {v} v adresáři Ma Petite Ferme.",
   "descRegion": "Objevte místní farmy a producenty v {v} v adresáři Ma Petite Ferme.",
   "descCity": "Objevte místní farmy a producenty v {v}, kteří prodávají přímo na Ma Petite Ferme.",
   "dirStatsTitle": "Moje veřejná stránka",
   "dirStatsViews": "Zobrazení profilu",
   "dirStatsWeb": "Kliknutí na web",
   "dirStatsPhone": "Kliknutí na telefon",
   "dirStats30d": "Posledních 30 dní",
   "pdpBack": "← Zpět na farmu",
   "pdpOther": "Další produkty z farmy",
   "pdpInStock": "Skladem",
   "pdpOut": "Vyprodáno",
   "pdpBy": "Prodává",
   "pdpHome": "Domů",
   "share": "Sdílet",
   "copied": "Odkaz zkopírován!",
   "favLogin": "Přihlásit se",
   "favRegister": "Vytvořit účet",
   "favName": "Jméno",
   "favEmail": "E-mail",
   "favPassword": "Heslo",
   "favToRegister": "Ještě nemáte účet? Zaregistrovat se",
   "favToLogin": "Již registrován? Přihlásit se",
   "favWelcome": "Vítejte!",
   "favTitle": "Moje oblíbené farmy",
   "favEmpty": "Zatím žádná oblíbená farma. Prozkoumejte adresář a klikněte na srdce ❤",
   "favLoginPrompt": "Přihlaste se, abyste mohli ukládat a nacházet své oblíbené farmy.",
   "favPwdHint": "Minimálně 6 znaků.",
   "fulfillTitle": "Kde vyzvednout vaše produkty ve vašem okolí",
   "fulfillPickup": "{n} farma/farmy nabízí/nabízejí vyzvednutí na místě",
   "fulfillDelivery": "{n} farma/farmy doručuje/doručují domů",
   "fulfillPoints": "Výdejní místa a města",
   "faqTitle": "Časté otázky",
   "relatedTitle": "Prozkoumejte také"
  }
 }
};
